var map = {
	"./assets/Executive1.svg": 7834,
	"./assets/MeetingHall1.svg": 2038,
	"./assets/MeetingHall2.svg": 9451,
	"./assets/TeamOffice1.svg": 9721,
	"./assets/TeamOffice2.svg": 9744,
	"./assets/accessibility.svg": 8549,
	"./assets/affordable.svg": 5413,
	"./assets/collaborative.svg": 1521,
	"./assets/comfortable.svg": 1836,
	"./assets/complimentary.svg": 4292,
	"./assets/constant.svg": 7362,
	"./assets/groups.svg": 4354,
	"./assets/image3.svg": 1341,
	"./assets/image4.svg": 5529,
	"./assets/img1.svg": 4826,
	"./assets/logo-dark.svg": 7705,
	"./assets/logo.svg": 9574,
	"./assets/map.svg": 5077,
	"./assets/next.svg": 8031,
	"./assets/options/Executive Office.svg": 5369,
	"./assets/options/Meeting Hall.svg": 5113,
	"./assets/options/Shared Space.svg": 3734,
	"./assets/options/Team Office.svg": 81,
	"./assets/s1.svg": 3765,
	"./assets/s2.svg": 1955,
	"./assets/security.svg": 6087,
	"./assets/serenity.svg": 9938,
	"./assets/service1.webp": 6457,
	"./assets/service2.svg": 1933,
	"./assets/service3.svg": 1114,
	"./assets/service4.svg": 6092,
	"./assets/sharedspace1.svg": 860,
	"./assets/sharedspace2.svg": 5486,
	"./assets/slide.png": 2568,
	"./assets/stimulating.svg": 7212,
	"./assets/video.svg": 3815,
	"./assets/wifi.svg": 5322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;